export default
    {
        path: '/files/:id?',
        mapPath: '/files',
        component: require('./index').default,
        parent: 'root',
    }
